import { useState } from "react";
import { withTranslation } from "react-i18next";

// Styles
import {
  Container,
  List,
  ListMobile,
  Content,
  Logocontent,
  CompanyLogoContainer,
  Linear,
  GTLogocontent,
} from "./Footer.styled";

// Own Components
import Link from "../Link";

// Own Assets
import LogoGT from "../../Assets/Img/G&TContinental.png";
import Logofooter from "../../Assets/Img/logo-sendola.png";
import Text from "../Text";

const Footer = () => {
  const [isShowPopup, setIsShowPopup] = useState(true);
  const handlePopUp = () => setIsShowPopup(!isShowPopup);

  return (
    <>
      <Container>
        <Content>
          <List>
            <li>
              <Link href="/contact-us" variant="white" size={1}>
                Contáctanos
              </Link>
            </li>
            {/* <li> It is commented on at the moment since they do not have a link
              <Link href="" onClick={handlePopUp} variant="white" size={1}>
                Términos y condiciones
              </Link>
            </li>
            <li>
              <Link href="" onClick={handlePopUp} variant="white" size={1}>
                Sobre Sendola
              </Link>
            </li>
          </List>
          <List>
            <li>
              <Link href="" onClick={handlePopUp} variant="white" size={1}>
                Política de privacidad
              </Link>
            </li> */}
          </List>
          <ListMobile>
            <li>
              <Link href="/contact-us" variant="white" size={1}>
                Contáctanos
              </Link>
            </li>
            {/* <li> It is commented on at the moment since they do not have a link
              <Link href="" onClick={handlePopUp} variant="white" size={1}>
                Términos y condiciones
              </Link>
            </li>
            <li>
              <Link href="" onClick={handlePopUp} variant="white" size={1}>
                Sobre Sendola
              </Link>
            </li>
            <li>
              <Link href="" onClick={handlePopUp} variant="white" size={1}>
                Política de privacidad
              </Link>
            </li>
            <li>
              <Link href="/contact-us" variant="white" size={1}>
                Contáctanos
              </Link>
            </li> */}
          </ListMobile>
        </Content>
        <GTLogocontent>
          <CompanyLogoContainer>
            <img src={Logofooter} alt="Sendola-2023" />
          </CompanyLogoContainer>
        </GTLogocontent>
        <Logocontent>
          <CompanyLogoContainer>
            <Text size={1} color="white">
              Partnered with
            </Text>
            <img src={LogoGT} alt="Sendola-2023" />
          </CompanyLogoContainer>
        </Logocontent>
      </Container>
      <Linear />
    </>
  );
};

export default withTranslation("ns")(Footer);
